import { useDocumentTitle } from "~src/hooks/useDocumentTitle"
import { SafeArea, Image, Toast } from "antd-mobile"
import React, { FC, useEffect, useState } from "react"
import { CopyToClipboard } from 'react-copy-to-clipboard';

import styles from "./index.module.less"
import { CouponItem, fetchCouponDetail } from "~src/service/coupon"
import useQuery from "~src/hooks/useQuery"

const Details: FC = () => {
  useDocumentTitle('券详情')
  const searchQuery = useQuery()
  const couponId = searchQuery("id")
  const [couponInfo, setCouponInfo] = useState<CouponItem>();
  useEffect(() => {
    getCouponDetail()
  }, [couponId])

  const getCouponDetail = async () => {
    const { couponInfo, description } = await fetchCouponDetail({ couponCardId: couponId })
    if (couponInfo) {
      setCouponInfo({ ...couponInfo, description })
    }
  }
  return <div className={styles.wrap}>
    <div className={styles.coupons}>
      <div className={styles['coupons-info']}>
        <div className={styles['coupons-info-container']}>
          <Image src={couponInfo?.cardIcon} className={styles['coupons-info-container-icon']} />
          <div className={styles['coupons-info-container-rf']}>
            <div className={styles['coupons-info-container-rf-title']}>{couponInfo?.title}</div>
            {couponInfo?.couponCardCode && <CopyToClipboard text={couponInfo?.couponCardCode} onCopy={() => Toast.show('已复制到粘贴板')}>
              <div className={styles['coupons-info-container-rf-codeinfo']}>
                <div className={styles['coupons-info-container-rf-code']}>{`券码：${couponInfo?.couponCardCode}`}</div>
                <Image className={styles['coupons-info-container-rf-copy']} src="https://resources-cn.miotech.com/static/mp2c/images/mp2c2.0/wallet/copy_icon.png" />
              </div>
            </CopyToClipboard>
            }
            {couponInfo?.endTime && <div>{`有效期至：${couponInfo?.endTime}`}</div>}
          </div>
        </div>
      </div>
      {
        couponInfo?.couponCardQrcodeBase64 && <div>
          <Image src={couponInfo?.couponCardQrcodeBase64} className={styles['coupons-qrcode']} fit="contain" />
          <div className={styles['coupons-tips']} >请将二维码对准检票POS机</div>
        </div>
      }
      <div className={styles['coupons-rule']}>
        <div dangerouslySetInnerHTML={{ __html: couponInfo?.description ?? '' }}></div>
      </div>
    </div>
    <SafeArea position='bottom' />
  </div >
}
export default Details
